/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Goals (KPI Targets) viewer. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["goals"] = "1.0.1"; } catch (e) {}
  var root, DATA = null, META = {}, PERIODS = {}, CUR = "USD", EDIT = null;
  var CURSYM = { USD: "$", EUR: "\u20AC", GBP: "\u00A3", CAD: "$", AUD: "$", JPY: "\u00A5" };
  function q(n) { return root ? root.querySelector('[data-d="' + n + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;" }[c]; }); }
  function nf(n) { return (+n || 0).toLocaleString(); }
  function ready(fn) { var d = false; function go() { if (d) return; d = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var k = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++k > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go(); }
  function api(p) { return GS.api(p + (p.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site)); }
  function post(p, b) { return GS.api(p + (p.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site), { method: "POST", body: JSON.stringify(b) }); }
  function fmt(v, unit) {
    v = +v || 0;
    if (unit === "currency") return (CURSYM[CUR] || "$") + v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    if (unit === "seconds") { var m = Math.floor(v / 60), s = Math.round(v % 60); return m + "m " + s + "s"; }
    if (unit === "ratio") return v.toFixed(2);
    return nf(Math.round(v));
  }

  function render() {
    var d = DATA; if (!d) return;
    var goals = d.goals || [];
    if (!goals.length) { q("empty").hidden = false; q("content").hidden = true; return; }
    q("empty").hidden = true; q("content").hidden = false;
    q("summary").innerHTML = '<div class="kpi-sum"><span class="kpi-sum-v">' + d.totals.on_track + '/' + d.totals.goals + '</span> goals on track</div>';
    q("cards").innerHTML = goals.map(card).join("");
    root.querySelectorAll("[data-goal]").forEach(function (el) {
      el.querySelector("[data-open]").onclick = function () { openDetail(+el.getAttribute("data-goal")); };
      el.querySelector("[data-edit]").onclick = function (e) { e.stopPropagation(); openBuilder(+el.getAttribute("data-goal")); };
      el.querySelector("[data-del]").onclick = function (e) { e.stopPropagation(); if (confirm(TT('goal.x.delete_this_goal'))) post("/plugin/goals/delete", { id: +el.getAttribute("data-goal") }).then(load); };
    });
  }
  function card(g) {
    var pct = Math.min(100, g.pct), col = g.on_track ? "#1FA463" : "#D97706";
    var badge = g.status === "paused" ? '<span class="kpi-badge paused">'+TR('goals.g.paused')+'</span>' : (g.on_track ? '<span class="kpi-badge ok">'+TT('goal.js.on_track')+'</span>' : '<span class="kpi-badge behind">'+TR('goals.g.behind')+'</span>');
    return '<div class="kpi-card" data-goal="' + g.id + '">' +
      '<div class="kpi-card-top"><div><div class="kpi-card-name" data-open>' + esc(g.name) + '</div><div class="kpi-card-sub">' + esc(g.metric_label) + ' \u00B7 ' + esc(g.period_label) + '</div></div>' +
      '<div class="kpi-card-menu"><button data-edit title="'+TT('goal.at.edit')+'">\u270E</button><button data-del title="'+TT('goal.at.delete')+'">\u00D7</button></div></div>' +
      '<div class="kpi-vals"><span class="kpi-cur">' + fmt(g.current, g.unit) + '</span><span class="kpi-tgt">/ ' + fmt(g.target, g.unit) + '</span>' + badge + '</div>' +
      '<div class="kpi-bar"><span class="kpi-fill" style="width:' + pct + '%;background:' + col + '"></span><span class="kpi-elapsed" style="left:' + Math.min(100, g.elapsed_pct) + '%" title="' + g.elapsed_pct + '% of period elapsed"></span></div>' +
      '<div class="kpi-foot"><span class="kpi-pct">' + g.pct + '%</span><span class="kpi-fc">' + (g.forecast_date === TR('goals.g.reached') ? "\u2713 Reached" : (g.on_track ? "Forecast: " + esc(g.forecast_date) : "Off pace")) + '</span><span class="kpi-prob">' + g.probability + '% likely</span></div></div>';
  }
  function openDetail(id) {
    if (window.GSLink) window.GSLink.write({ id: id });   // the open view becomes linkable
    api("/plugin/goals/get?id=" + id).then(function (r) {
      if (!r.ok) return; var g = r.data.goal; var sec = q("detail"); sec.hidden = false; q("d-title").textContent = g.name;
      /* KPI trend with a readable scale. It used to be a bare 300x60 sparkline stretched with
         preserveAspectRatio="none": you could see the shape but not a single value, and the target line
         had no number on it. Now it carries a Y scale, the first/last date, a labelled target, and a
         hover readout per point. Aspect ratio is uniform so the text isn't distorted. */
      var s = g.series || [];
      var rawMax = Math.max.apply(null, s.map(function (x) { return +x.value || 0; }).concat([+g.target || 0, 1]));
      /* Round the scale top to something a person would choose, so the labels read cleanly. */
      function niceMax(v) { var p = Math.pow(10, Math.floor(Math.log(v) / Math.LN10)), f = v / p;
        return (f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10) * p; }
      var max = niceMax(rawMax * 1.06);
      var W = 320, H = 96, L = 44, R = 10, T = 10, B = 20, PW = W - L - R, PH = H - T - B;
      var X = function (i) { return L + (s.length < 2 ? PW / 2 : i / (s.length - 1) * PW); };
      var Y = function (v) { return T + PH - ((+v || 0) / max) * PH; };
      var pts = s.map(function (x, i) { return X(i).toFixed(1) + "," + Y(x.value).toFixed(1); }).join(" ");
      var ty = Y(g.target).toFixed(1);
      var dayOf = function (x, i) { return String(x.day || x.d || x.date || ("#" + (i + 1))); };
      /* Y gridlines + labels at 0, half, full. */
      var grid = "", yl = "";
      [0, 0.5, 1].forEach(function (f) {
        var v = max * f, yy = Y(v);
        grid += '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + yy.toFixed(1) + '" y2="' + yy.toFixed(1) + '" stroke="#EEF1F6"/>';
        yl += '<text x="' + (L - 6) + '" y="' + (yy + 3.2).toFixed(1) + '" text-anchor="end" font-size="9" fill="#9AA1AC">' + fmt(v, g.unit) + '</text>';
      });
      /* X: first and last date only — more would collide at this width. */
      var xl = "";
      if (s.length) {
        xl += '<text x="' + L + '" y="' + (T + PH + 13) + '" text-anchor="start" font-size="9" fill="#9AA1AC">' + esc(dayOf(s[0], 0)) + '</text>';
        if (s.length > 1) xl += '<text x="' + (W - R) + '" y="' + (T + PH + 13) + '" text-anchor="end" font-size="9" fill="#9AA1AC">' + esc(dayOf(s[s.length - 1], s.length - 1)) + '</text>';
      }
      /* One hover target per point; the app tooltip engine picks data-tip up automatically. */
      var hit = "", colw = s.length > 1 ? PW / (s.length - 1) : PW;
      s.forEach(function (x, i) {
        hit += '<rect x="' + (X(i) - colw / 2).toFixed(1) + '" y="' + T + '" width="' + colw.toFixed(1) + '" height="' + PH +
               '" fill="transparent" data-tip="' + esc(dayOf(x, i)) + ' \u2014 ' + esc(fmt(x.value, g.unit)) +
               ' of ' + esc(fmt(g.target, g.unit)) + ' target"></rect>';
      });
      var axes = '<line x1="' + L + '" x2="' + L + '" y1="' + T + '" y2="' + (T + PH) + '" stroke="#D7DEE8"/>' +
                 '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + (T + PH) + '" y2="' + (T + PH) + '" stroke="#D7DEE8"/>';
      q("d-body").innerHTML =
        '<div class="kpi-dgrid">' +
        dk(TR('goals.g.current'), fmt(g.current, g.unit)) + dk(TR('goals.g.target'), fmt(g.target, g.unit)) + dk(TR('goals.g.progress'), g.pct + "%") +
        dk(TR('goals.g.projected'), fmt(g.projected, g.unit)) + dk(TR('goals.g.forecast'), esc(g.forecast_date)) + dk(TR('goals.g.likelihood'), g.probability + "%") + '</div>' +
        '<div class="kpi-trend"><svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMid meet" style="width:100%;height:auto;display:block" role="img" aria-label="Cumulative ' + esc(g.metric_label) + ' against target">' +
        grid +
        '<line x1="' + L + '" y1="' + ty + '" x2="' + (W - R) + '" y2="' + ty + '" stroke="#D97706" stroke-dasharray="4 3" stroke-width="1"/>' +
        '<text x="' + (W - R) + '" y="' + (+ty - 4).toFixed(1) + '" text-anchor="end" font-size="9" fill="#D97706">Target ' + esc(fmt(g.target, g.unit)) + '</text>' +
        (pts ? '<polyline points="' + pts + '" fill="none" stroke="#1FA463" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' : '') +
        axes + yl + xl + hit +
        '</svg><div class="kpi-trend-l"><span>Cumulative ' + esc(g.metric_label) + ' this period</span><span class="kpi-tgtline">'+TR('goals.g.target')+'</span></div></div>';
    });
  }
  function dk(l, v) { return '<div class="kpi-dk"><div class="kpi-dk-v">' + v + '</div><div class="kpi-dk-l">' + esc(l) + '</div></div>'; }

  function fillSelects() {
    var m = q("b-metric"); m.innerHTML = Object.keys(META).map(function (k) { return '<option value="' + k + '">' + esc(META[k].label) + '</option>'; }).join("");
    var p = q("b-period"); p.innerHTML = Object.keys(PERIODS).map(function (k) { return '<option value="' + k + '">' + esc(PERIODS[k]) + '</option>'; }).join("");
    m.onchange = function () { q("b-eventwrap").hidden = m.value !== "event_count"; };
  }
  function openBuilder(id) {
    EDIT = id || null; q("b-title").textContent = id ? "Edit goal" : TR('goals.g.new_goal');
    var g = id ? (DATA.goals.filter(function (x) { return x.id === id; })[0] || {}) : {};
    q("b-name").value = g.name || ""; q("b-metric").value = g.metric || "visitors"; q("b-period").value = g.period || "month";
    q("b-target").value = g.target != null ? g.target : ""; q("b-status").value = g.status || "active";
    q("b-event").value = g.event_name || ""; q("b-eventwrap").hidden = (g.metric || "visitors") !== "event_count";
    q("builder").hidden = false;
  }
  function saveBuilder() {
    var body = { name: q("b-name").value.trim(), metric: q("b-metric").value, period: q("b-period").value,
      target_value: parseFloat(q("b-target").value) || 0, status: q("b-status").value, event_name: q("b-event").value.trim() };
    var url = EDIT ? "/plugin/goals/update" : "/plugin/goals/create"; if (EDIT) body.id = EDIT;
    post(url, body).then(function (r) { if (r.ok) { q("builder").hidden = true; load(); } });
  }

  function load() { api("/plugin/goals/list").then(function (r) { if (!r.ok) return; DATA = r.data; META = r.data.metrics || {}; PERIODS = r.data.periods || {};
    if (!Object.keys(META).length) return; fillSelects(); render(); }); }
  function init() {
    root = document.querySelector('.gs-goals[data-d="root"]'); if (!root) return;
    q("add").onclick = q("add2").onclick = function () { openBuilder(null); };
    q("b-close").onclick = q("b-cancel").onclick = function () { q("builder").hidden = true; };
    q("b-save").onclick = saveBuilder; q("d-close").onclick = function () { q("detail").hidden = true; };
    api("/plugin/goals/settings").then(function (r) { if (r.ok && r.data.settings) CUR = r.data.settings.currency || "USD"; load(); });
  }
  /* Deep link: /goals?id=<v> opens that view directly, so it can be linked from an email,
     a dashboard widget or another report. The spelling lives in GSLink so no two pages can
     disagree about it. The inline fallback covers the window before gs-deeplink.js is deployed —
     it must ASSIGN, not return: an early return exits gsDeep() and the opener never fires.
     Anything malformed is ignored and the normal list loads. */
  function gsDeep() {
    var v = null;
    if (window.GSLink) {
      v = window.GSLink.read({ id: "int" }).id;
    } else {
      try {
        var p = new URLSearchParams(location.search);
        var _n = parseInt(String(p.get("id") || "").replace(/[^0-9-]/g, ""), 10);
        v = isNaN(_n) ? null : _n;
      } catch (e) { v = null; }
    }
    if (v !== null && v !== "") openDetail(v);
  }
  ready(function () { init(); gsDeep(); });
})();
